import { DefineComponent, FunctionalComponent } from "vue";

type FieldWrapperProps = {};

const FieldWrapper: FunctionalComponent<FieldWrapperProps> = function (_props: FieldWrapperProps, context)
{
    return (
        <div class="fieldWrapper" {...context.attrs}>
            {context.slots.default && context.slots.default()}
        </div>
    );
};

FieldWrapper.props = [];
export default FieldWrapper as unknown as DefineComponent<FieldWrapperProps, JSX.Element>;
